import List from "@mui/material/List";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import type { LanguageSummary } from "features/languages/types";
import { multiSelectorRow, multiSelectorPicker } from "./styles";

export const MultiselectRow = ({
  title,
  items,
  handleToggleAll,
  numberOfChecked,
  handleToggle,
  checked,
}: {
  title: React.ReactNode;
  items: LanguageSummary[];
  handleToggleAll: any;
  numberOfChecked: any;
  handleToggle: any;
  checked: LanguageSummary[];
}) => (
  <Card sx={multiSelectorRow}>
    <CardHeader
      sx={{ px: 2, py: 1 }}
      avatar={
        <Checkbox
          onClick={handleToggleAll(items)}
          checked={numberOfChecked(items) === items.length && items.length !== 0}
          indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
          disabled={items.length === 0}
          inputProps={{
            "aria-label": "all items selected",
          }}
        />
      }
      title={title}
      subheader={`${numberOfChecked(items)}/${items.length} selected`}
    />
    <Divider />
    <List sx={multiSelectorPicker} dense component="div" role="list">
      {items.map((item: LanguageSummary) => {
        const labelId = `transfer-list-all-item-${item.id}-label`;

        return (
          <ListItemButton key={item.id} role="listitem" onClick={handleToggle(item)}>
            <ListItemIcon>
              <Checkbox
                checked={checked.some(el => el.id === item.id)}
                tabIndex={-1}
                disableRipple
                inputProps={{
                  "aria-labelledby": labelId,
                }}
              />
            </ListItemIcon>
            <ListItemText id={labelId} primary={item.name} secondary={item.id} />
          </ListItemButton>
        );
      })}
    </List>
  </Card>
);
